import { useDocumentTitle } from "@/lib/use-document-title";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth-context";

function AfLogin() {
  useDocumentTitle("ÅF-Portal — Lagamobilen Access");
  const navigate = useNavigate();
  const { session, staff, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && session && staff?.active) {
    return <Navigate to="/af-portal/dashboard" replace />;
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr("");
    if (!email || !pwd) { setErr("Ange e-post och lösenord"); return; }
    setBusy(true);
    const { data, error } = await supabase.auth.signInWithPassword({ email, password: pwd });
    if (error) { setBusy(false); setErr("Fel e-post eller lösenord"); return; }

    // Verify staff row exists and is active
    const { data: row } = await supabase
      .from("staff" as any)
      .select("id, active")
      .eq("user_id", data.user!.id)
      .maybeSingle();
    if (!row || !(row as any).active) {
      await supabase.auth.signOut();
      setBusy(false);
      setErr("Det här kontot har inte tillgång till ÅF-portalen.");
      return;
    }
    navigate("/af-portal/dashboard");
  }

  return (
    <div className="min-h-screen bg-[var(--color-soft)] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/access" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-4">
          <ArrowLeft className="w-4 h-4" /> Tillbaka
        </Link>
        <div className="card-soft p-8">
          <h1 className="!text-2xl text-center mb-2">ÅF-Portal</h1>
          <p className="text-center text-sm text-muted-foreground mb-6">Endast för butikspersonal</p>
          <form onSubmit={submit}>
            <div className="mb-4">
              <label className="label-field">E-post</label>
              <input className="input-field" type="email" placeholder="namn@lagamobilen.se" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div className="mb-2">
              <label className="label-field">Lösenord</label>
              <input type="password" className="input-field" value={pwd} onChange={e => setPwd(e.target.value)} />
            </div>
            <div className="text-right mb-4">
              <Link to="/access/glomt-losenord" className="text-xs text-primary hover:underline">Glömt lösenord?</Link>
            </div>
            {err && <p className="text-destructive text-xs mb-3">{err}</p>}
            <button type="submit" disabled={busy} className="btn-pill w-full">{busy ? "Loggar in…" : "Logga in"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AfLogin;
